import { format } from 'date-fns'

import { CLOSED_STATUS_NAME } from '../../models/helpdeskConstants'

import ColumnFilterDatePagination from '../../components/table/components/ColumnFilterDatePagination'
import SelectColumnFilterPaginated from '../../components/table/components/SelectColumnFilterPaginated'

export function getHelpDeskTicketsColumns({ t, handleFilterChange, statuses, priorities, categories, archive }) {
  const toOptions = (items) => items.map((item) => ({ label: item.name, value: String(item.id) }))

  const createSelectFilter = (providedOptions) => {
    const TicketSelectFilter = ({ column }) => (
      <SelectColumnFilterPaginated
        column={column}
        handleFilterChange={handleFilterChange}
        advancedOptions
        providedOptions={providedOptions}
      />
    )
    return TicketSelectFilter
  }

  const dateFilter = ({ column }) => (
    <ColumnFilterDatePagination column={column} handleFilterChange={handleFilterChange} />
  )

  const visibleStatuses = statuses.filter((status) =>
    archive ? status.name === CLOSED_STATUS_NAME : status.name !== CLOSED_STATUS_NAME,
  )

  return [
    {
      Header: t('support.list.ticket_number'),
      accessor: 'ticket_number',
    },
    {
      Header: t('support.list.subject'),
      accessor: 'subject',
    },
    {
      Header: t('support.list.status'),
      id: 'status_id',
      accessor: (ticket) => ticket.status?.name,
      Filter: createSelectFilter(toOptions(visibleStatuses)),
    },
    {
      Header: t('support.list.priority'),
      id: 'priority_id',
      accessor: (ticket) => ticket.priority?.name,
      Filter: createSelectFilter(toOptions(priorities)),
    },
    {
      Header: t('support.list.category'),
      id: 'category_id',
      accessor: (ticket) => ticket.category?.name,
      Filter: createSelectFilter(toOptions(categories)),
    },
    {
      Header: t('support.list.created_at'),
      accessor: 'created_at',
      Cell: ({ value }) => format(new Date(value), 'dd.MM.yyyy'),
      Filter: dateFilter,
    },
  ]
}
